import { showError } from "../Notifications/Notification";
import { getLocalStorage } from "../utils";
import { GENERIC_ERROR_MESSAGE } from "../constants";

const handleUserInactive = (errorMsg) => {
  localStorage.clear();
  showError(errorMsg || "You have been deactivated.");
  if (window.location.pathname !== "/sign-in") {
    setTimeout(() => {
      window.location.href = "/sign-in";
    }, 2000);
  }
};

const handleUnauthorised = () => {
  window.location.href = "/unauthorized";
};

// Add a request interceptor
export function onRequest(config) {
  const auth = getLocalStorage("AUTH_DETAILS");
  if (auth) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${auth.access}`,
    };
  }
  return config;
}

export function onRequestError(error) {
  return Promise.reject(error);
}

// Add a response interceptor
export function onResponse(response) {
  if (response?.data?.status === 401) {
    handleUserInactive(response?.data?.error?.detail);
  } else if (response?.data?.status === 403) {
    handleUnauthorised();
  } else {
    return response;
  }
}

export function onResponseError(error) {
  const hasResponse = Boolean(error?.response);
  const status = Number(
    hasResponse ? error.response.headers.status || error.response.status : -1
  );
  if (status === 401) {
    handleUserInactive(error?.response?.data?.message);
  } else if (status === 403) {
    handleUnauthorised();
  } else {
    // Prefer a specific, user-appropriate message from the server.
    const serverError = error?.response?.data?.error;
    if (serverError) return Promise.reject(serverError);
    // Otherwise fall back to the standardised generic message. Flag the
    // no-response (backend-unreachable/timeout) case so callers such as the
    // login flow can substitute a context-specific message.
    return Promise.reject({
      detail: [error?.response?.data?.message || GENERIC_ERROR_MESSAGE],
      isNetworkError: !hasResponse,
    });
  }
}
